import { getWideGroupListAdminsWidgetConfig } from '../../UserWidgets.deviation_gruser/GroupList/widgetConfig';
import { getMyBadgesWidgetConfig } from '../../UserWidgets.deviation_gruser/MyBadges/widgetConfig';
import { getStatsWidgetConfig } from '../../UserWidgets.deviation_gruser/Stats/widgetConfig';
import getCoverDeviationWidgetConfig from '../../UserWidgets.deviation_gruser/CoverDeviation/widgetConfig';
import { getGroupAboutWidgetWideConfig } from '../../GroupWidgets.deviation_gruser/GroupAbout/widgetWideConfig';

export const getAboutSectionWidgetConfigs = ({ t, dispatch }) => ({
  topSecret: {
    coverDeviation: getCoverDeviationWidgetConfig({ t, dispatch }),
  },
  topRight: {
    groupAbout: getGroupAboutWidgetWideConfig({ t, dispatch }),
  },
  midRight: { userstats: getStatsWidgetConfig({ t, dispatch }) },
  bottomRight: {
    groupListAdmins: getWideGroupListAdminsWidgetConfig({ t, dispatch }),
    badgesActivity: getMyBadgesWidgetConfig({ t, dispatch }),
  },
});
